import EmojiPicker from "emoji-picker-react";
import { useEffect, useState } from "react";
import { Popover } from "react-tiny-popover";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { useSlate } from "slate-react";
import { Transforms } from "slate";

const EmojiToolbar = (props) => {
   const { isShow, setIsShow, maxLength, getLengthText, onBlur, isFocus } = props;
   const editor = useSlate();
   const [selection, setSelection] = useState(null);
   useEffect(() => {
      if (editor.selection) {
         setSelection(editor.selection);
      }
   }, [editor.selection]);

   const onEmojiClick = (emoji) => {
      if (selection) {
         Transforms.select(editor, selection);
         if (emoji.native && maxLength && emoji.native.length + getLengthText(editor.children) > maxLength) {
            return;
         }
         Transforms.insertText(editor, emoji.native);
      }
   }

   return (
      <div className="emoji-picker-container plugins-controls plugins-controls-emoji ps-relative">
         <Popover
            isOpen={isShow}
            positions={['bottom']}
            onClickOutside={() => {
               setIsShow(false);
               setTimeout(() => {
                  if (!isFocus) {
                     onBlur();
                  }
               }, 100)
            }}
            clickOutsideCapture={true}
            content={<Picker
               className="emoji-container"
               data={data}
               previewPosition="none"
               navPosition="bottom"
               dynamicWidth={true}
               onEmojiSelect={onEmojiClick}
               style={{ top: 10 }}
            />}
         >
            <a className="pointer" onClick={() => setIsShow(!isShow)}>
               <span className="text-smallest">
                  <svg ariaHidden="true" focusable="false" dataprefix="far" dataicon="smile" className="svg-inline--fa fa-smile fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg"
                     viewBox="0 0 496 512">
                     <path fill="currentColor"
                        d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm4 72.6c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.1-8.4-25.3-7.1-33.8 3.1z">
                     </path>
                  </svg>
               </span>
            </a>
         </Popover>
      </div>
   )
}

export default EmojiToolbar;